    <div class="profile-sidebar h-100">
        <h6 class="mb-2">{{ 'myaccount.profile' | translate }}</h6>
        <div class="profile-usermenu">
            <ul class="nav">
                <li>
                    <a [routerLink]="['/my-account']" routerLinkActive="active">
                        <i class="fas fa-user-alt icon"></i> {{ 'myaccount.myaccount' | translate }}
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/my-account/editprofile']" routerLinkActive="active">
                        <i class="fas fa-pencil-alt icon"></i> {{ 'myaccount.editprofile' | translate }} </a>
                    </li>

                    <li>
                        <a [routerLink]="['/my-account/myaddresses']" routerLinkActive="active">
                            <i class="fas fa-map-marker icon"></i> {{ 'myaccount.myaddresses' | translate }}  </a>
                        </li>
                        <!-- <li>
                            <a [routerLink]="['/my-account/billing-paymemnts']" routerLinkActive="active">
                                <i class="far fa-credit-card icon"></i> Billing & Paymemnts </a>
                            </li> -->
                            <li>
                                <a [routerLink]="['/my-account/loyalty-account']" routerLinkActive="active">
                                    <i class="fas fa-wallet icon"></i> {{ 'myaccount.loyalty_acc' | translate }}</a>
                            </li>

                            <li>
                                <a [routerLink]="['/my-account/my-wishlist']" routerLinkActive="active">
                                    <i class="fas fa-heart icon"></i> {{ 'myaccount.myfavorites' | translate }} </a>
                            </li>

                            <!-- <li>
                                <a [routerLink]="['/my-account/saved-cards']" routerLinkActive="active">
                                    <i class="fas fa-heart icon"></i> {{ 'myaccount.savedcards' | translate }} </a>
                            </li> -->

                   </ul>
                </div>
                <h6 class="mb-2 mt-4">{{ 'myaccount.order' | translate }}</h6>
                <div class="profile-usermenu">
                    <ul class="nav">
                        <li>
                            <a [routerLink]="['/my-account/orders']" routerLinkActive="active">
                                <i class="fas fa-box-open icon"></i> {{ 'myaccount.myorders' | translate }} </a>
                            </li>
                            <li>
                                <a [routerLink]="['/my-account/ongoing-orders']" routerLinkActive="active">
                                    <i class="fas fa-truck-moving icon"></i> {{ 'myaccount.track_order' | translate }}</a>
                                </li>
                            <li>                            
                                <a (click)="logout()" > <i class="fas fa-lock icon"></i>{{ 'HOME.logout' | translate }}</a>
                            </li>
                      </ul>
                    </div>
                    <!-- END MENU -->
                </div>

